import {
    getMeteringRecord,
    listMeteringRecords
} from './queries';
import {
    createMeteringRecord,
    deleteMeteringRecord,
    updateMeteringRecord,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {MeteringRecord} from "../types.ts";
import {
    notifyError,
    notifySuccess
} from "../../../components/PlatformNotification";
import {generateClient} from "aws-amplify/api";
import {ListRecordsQuery} from "../../../types";


export type ListMeteringRecords = {
    listMeteringRecords: { items: MeteringRecord[], nextToken: string }
}

export type GetMeteringRecord = {
    getMeteringRecord: MeteringRecord
}

export type CreateMeteringRecord = {
    createMeteringRecord: MeteringRecord
}

export type UpdateMeteringRecord = {
    updateMeteringRecord: MeteringRecord
}

export type DeleteMeteringRecord = {
    deleteMeteringRecord: string
}


const client = generateClient();


export const fetchRecords = async (query: ListRecordsQuery) => {
    try {
        const response = await client.graphql<GraphQLQuery<ListMeteringRecords>>({
                                                                                     query: listMeteringRecords,
                                                                                     variables: {
                                                                                         ...query
                                                                                     },
                                                                                 });
        return {
            items: response.data?.listMeteringRecords.items,
            nextToken: response.data?.listMeteringRecords.nextToken
        }

    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetMeteringRecord>>({
                                                                                   query: getMeteringRecord,
                                                                                   variables: {id: id},
                                                                               });
        return response.data?.getMeteringRecord;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const add = async (payload: object) => {

    try {
        const response = await client.graphql<GraphQLQuery<CreateMeteringRecord>>({
                                                                                      query: createMeteringRecord,
                                                                                      variables: {input: payload},
                                                                                  });
        console.debug('in the service response', response);
        notifySuccess('Metering record created');
        return response.data?.createMeteringRecord;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const update = async (id: string, record: MeteringRecord) => {

    console.debug('IN UPDATE', id, record);

    delete record.created;
    delete record.updated;

    try {
        const response = await client.graphql<GraphQLQuery<UpdateMeteringRecord>>({
                                                                                      query: (updateMeteringRecord),
                                                                                      variables: {input: record},
                                                                                  });
        notifySuccess('Metering record updated');
        return response.data?.updateMeteringRecord;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteMeteringRecord>>({
                                                                                      query: (deleteMeteringRecord),
                                                                                      variables: {input: {id: id}},

                                                                                  });
        notifySuccess('Metering record deleted')
        return response.data?.deleteMeteringRecord;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};
